var _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDraggableIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.345,
    cy: 1.867,
    rx: 1.345,
    ry: 1.488,
    fill: "#C4CCDD"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.345,
    cy: 7.816,
    rx: 1.345,
    ry: 1.488,
    fill: "#C4CCDD"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.345,
    cy: 13.767,
    rx: 1.345,
    ry: 1.488,
    fill: "#C4CCDD"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.728,
    cy: 1.867,
    rx: 1.345,
    ry: 1.488,
    fill: "#C4CCDD"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.728,
    cy: 7.816,
    rx: 1.345,
    ry: 1.488,
    fill: "#C4CCDD"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.728,
    cy: 13.767,
    rx: 1.345,
    ry: 1.488,
    fill: "#C4CCDD"
  })));
}
export default SvgDraggableIcon;